<template>
  <div class="">
    <div class="lg:flex md:flex mb-5">
      <div class="lg:w-5/12 md:w-5/12 relative">
        <Map4 :record="get_service" />
      </div>
      <div
        class="lg:w-7/12 md:w-7/12 lg:mt-28 md:mt-20 mt-4 lg:px-8 md:px-8 px-5"
      >
        <Grid4 :record="get_service" :location="location" />
        <!-- <Pagination /> -->
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
import Map4 from "./components/Map4.vue";
import Grid4 from "./components/Grid4.vue";
import Pagination from "./components/Paginationn.vue";
import { mapState } from "vuex";

export default {
  props: ["location"],
  components: {
    Map4,
    Footer,
    DownloadApp,
    Grid4,
    Pagination,
  },
  method: {
    async init() {},
  },
  async mounted() {
    // console.log("this.$route.path", this.$route.query.service);
    // this.userDetails = sessionStorage.getItem("token");
    // try {
    //   const getServices = await this.$store
    //     .dispatch("services/get_service", {
    //       serviceName: this.$route.query.service,
    //     })
    //     .then((result) => {
    //       if (this.userDetails === null) {
    //         this.$swal
    //           .fire({
    //             title: "Login!",
    //             text: "Please login to continue",
    //             icon: "info",
    //             confirmButtonText: "Okay",
    //             confirmButtonColor: "#830c81",
    //             showCancelButton: false,
    //           })
    //           .then((result) => {
    //             return this.$router.push({ name: "signin" });
    //           });
    //         return;
    //       }
    //     });
    // } catch (error) {
    //   console.log(error);
    // }
  },
  computed: {
    ...mapState("services", ["get_service"]),
    ...mapState("services", { get_AllService: "get_AllService" }),
    ...mapState("auth", ["user"]),
  },
};
</script>

<style></style>
